'use strict';

/**
 *  1) Styles at the top of file.
 *  !!! Do not delete, this is for webpack building. !!! All scss files must be included in /assets/src/scss/main.scss
 */
import '../scss/main.scss';

/**
 * 2) Import External (3d-part) JS/jQuery Libs, Extensions like: bootstrap, datepicker, fadeSlider, ect.
 * !!! Import Only required components of Bootstrap (NOT whole library).
 */
// import Modal from 'bootstrap/js/dist/modal'; // uncomment for use

/**
 *  3) Your custom modules and call function here
 */
// Test examples, to show usage approach. Can be deleted
import { testJqueryFunc1, testJqueryFunc2 } from "./modules/test-import-jquery-func";
import { ajaxStartExample } from "./modules/ajax-start-example";
// End test examples. Can be deleted

import { slickSliders } from "./modules/slick-slider";
jQuery(document).on("ready", function ($) {
  /**
   * To use $ symbol inside your function you should pass jQuery variable as param of function
   */
  // Test examples, to show usage approach. Can be deleted
  testJqueryFunc1(jQuery, 'TEXT: ');
  testJqueryFunc2(jQuery);
  ajaxStartExample(jQuery); // AJAX test example
  // End test examples. Can be deleted

  slickSliders();
  var rellax = new Rellax('.rellax');
  jQuery('.hamburger').on('click', function () {
    jQuery(this).toggleClass('active');
    jQuery('.mobile-menu').toggle();
  });

  //Header
  var lastScrollTop = 100;
  var $header = jQuery('header');
  jQuery(window).on('scroll', function () {
    var currentScroll = jQuery(this).scrollTop();
    if (currentScroll === 0) {
      $header.removeClass('scroll-up scroll-down');
      lastScrollTop = 0;
      return;
    }
    if (currentScroll > lastScrollTop) {
      // Scrolling down
      $header.removeClass('scroll-up').addClass('scroll-down');
    } else {
      // Scrolling up
      $header.removeClass('scroll-down').addClass('scroll-up');
    }
    lastScrollTop = currentScroll;
  });
  jQuery('.header-nav li').each(function () {
    jQuery(this).addClass('menu-item-default');
  });
  jQuery('.header-nav li').mouseover(function () {
    jQuery('.header-nav li').not(jQuery(this)).removeClass('menu-item-default');
  });
  jQuery('.header-nav li').mouseleave(function () {
    jQuery('.header-nav li').addClass('menu-item-default');
  });

  //Footer
  jQuery('.footer-nav li').each(function () {
    jQuery(this).addClass('menu-item-default');
  });
  jQuery('.footer-nav li').mouseover(function () {
    jQuery('.footer-nav li').not(jQuery(this)).removeClass('menu-item-default');
  });
  jQuery('.footer-nav li').mouseleave(function () {
    jQuery('.footer-nav li').addClass('menu-item-default');
  });
  var ticking = false;
  function updateParallax() {
    var scrollTop = jQuery(window).scrollTop();
    var winH = jQuery(window).height();
    jQuery('.parallax-banner-image-holder').each(function () {
      var $container = jQuery(this);
      var $img = $container.find('img');
      var offsetTop = $container.offset().top;
      var height = $container.outerHeight();
      var progress = (scrollTop + winH - offsetTop) / (winH + height);
      progress = Math.max(0, Math.min(1, progress));
      var move = (progress - 0.2) * 200;
      $img.css('transform', 'translate3d(0,' + move + 'px,0)');
    });
    ticking = false;
  }
  jQuery(window).on('scroll resize', function () {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  });
  updateParallax();
  document.querySelectorAll('.gallery-section.is-style-default .wp-block-gallery .wp-block-image').forEach(function (item, index) {
    item.classList.add('rellax');
    if (index === 2 || index === 3) {
      item.setAttribute('data-rellax-speed', '-0.7');
    } else {
      item.setAttribute('data-rellax-speed', '-0.3');
    }

    // smooth animation
    item.style.transition = 'transform 0.35s ease-out';
    item.style.willChange = 'transform';
  });
  if (typeof Rellax !== 'undefined') {
    new Rellax('.gallery-section .rellax', {
      center: true,
      round: true
    });
  }
});